// Based on https://github.com/afconsult/quill-mention/

import Embed from 'quill/blots/embed';

class MentionBlot extends Embed {
  static create(data) {
    const node = super.create();
    return MentionBlot.configureNode(node, data);
  }

  static configureNode(element, data) {
    const denotationChar = document.createElement('span');
    denotationChar.className = 'ql-mention-denotation-char';
    denotationChar.innerHTML = '@';
    element.appendChild(denotationChar);
    element.innerHTML += data.username;
    element.dataset.id = data.id;
    element.dataset.username = data.username;

    return element;
  }

  static value(domNode) {
    return {
      id: domNode.dataset.id,
      username: domNode.dataset.username,
    };
  }
}

MentionBlot.blotName = 'mention';
MentionBlot.tagName = 'span';
MentionBlot.className = 'ql-mention';

export default MentionBlot;
